module.exports = __webpack_public_path__ + "img/wallet-logo.4ff1aedd.svg";